// Modules
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

// PWA
import './registerServiceWorker'  // Import ServiceWorker

// Fonts CSS
import './assets/fonts/AmpleSoftPro.css'
import './assets/fonts/Gilroy.css'

// Modules CSS
import './assets/tailwind.css'  // Import TailwindCSS
import './assets/fontawesome/css/all.min.css'   // Import FontAwesome

// Custom CSS
import './assets/global.css'


// Create App
const app = createApp(App)

// Use Modules
app.use(createPinia())
app.use(router)

// Mount App
app.mount('body#app')
